import type { Color } from './types.js';

export const BASE_PALETTE: readonly Color[] = [
  '#F28B82',
  '#CE93D8',
  '#90CAF9',
  '#A5D6A7',
  '#FFCC80',
  '#F48FB1',
  '#80DEEA',
] as const;

export const LOCKED_COLOR: Color = '#2c3142';
export const PENALTY_COLOR: Color = '#3a3f4e';
export const START_HALO: Color = '#ffffff';
export const END_HALO: Color = '#fde047';

export const colorCountForLevel = (level: number): number => {
  const c = 5 + Math.floor((level - 1) / 5);
  return Math.min(7, Math.max(5, c));
};

export const paletteForLevel = (level: number): readonly Color[] => {
  return BASE_PALETTE.slice(0, colorCountForLevel(level));
};
